import { fetchWrapper } from "@/helpers/fetch-wrapper";

/**
 * Serwis do obsługi VMS (tablice zmiennej treści, Variable Message Signs)
 */
class Vms {
  /**
   * Pobiera status wszystkich grup VMS z API.
   * Zwraca dwie mapy: statusy grup oraz ich opisy.
   */
  async getAllGroupStatus() {
    try {
      // Wywołanie endpointa z informacjami o grupach VMS
      const response = await fetchWrapper.get(`${process.env.VUE_APP_API_URL}/vms-groups-status`);
  
      // Słownik z przypisaniem: id grupy -> tablice VMS w tej grupie
      const groupsStatus = {};
      // Słownik z przypisaniem: id grupy -> opis grupy
      const groupsDescription = {};

      // Wyciąga opisy grup po id
      response.forEach(group => { 
        groupsDescription[group.group.id] = group.group.description;
      });
  
      // Wyciąga statusy (obiekty VMS) po id grupy
      response.forEach(group => {
        groupsStatus[group.group.id] = group.vms;
      });

      // Zwraca tablicę [statusy, opisy]
      return [groupsStatus, groupsDescription];
    } catch (error) {
      console.error('Błąd podczas pobierania danych:', error);
      return {};
    }
  }  

  /**
   * Pobiera obrazek (np. podgląd znaku VMS) po id jako blob, konwertuje na base64.
   * Zwraca base64 (do <img :src="...">).
   */
  async getImageForSign(id) {
    return fetchWrapper.getBlob(`${process.env.VUE_APP_API_URL}/vms-contents/${id}/image`)
      .then(fetched => {
        return this.blobToBase64(fetched);
      })
      .catch(error =>{
        console.error(error);
      });
  }

  /**
   * Konwertuje obiekt Blob do formatu base64 (do wyświetlania obrazka).
   */
  blobToBase64(blob) {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  }

  /**
   * Pobiera dostępne treści (warianty komunikatów) dla tablic VMS.
   */
  getContents() {
    return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/vms-contents`);
  }

  /**
   * Włącza wybrany wariant komunikatu na grupie VMS.
   * @param {Number} groupId - ID grupy VMS
   * @param {Number} variant - numer wariantu (np. treść komunikatu)
   */
  enableVms(groupId, variant) {
    return fetchWrapper.put(`${process.env.VUE_APP_API_URL}/vms-groups-status/${groupId}/variant/${variant}`);
  }

  /**
   * Wyłącza komunikat na grupie VMS.
   * @param {Number} groupId - ID grupy
   */
  disableVms(groupId) {
    return fetchWrapper.delete(`${process.env.VUE_APP_API_URL}/vms-groups-status/${groupId}/variant`);
  }
}

// Eksport singletonu klasy
export default new Vms();
